// external
import { CanMatchFn, Router, RouterModule, Routes } from "@angular/router";
import { inject, Injectable, NgModule } from "@angular/core";

import { ErrorComponent, NotFoundComponent, AboutComponent } from "./pages";
import { SelfServMetaCache } from "./shared";

export const canMatchQna: CanMatchFn = () => {
  return inject(CanMatchQna).canMatch();
};

@Injectable()
export class CanMatchQna {
  private readonly cache = inject(SelfServMetaCache);
  private readonly router = inject(Router);

  canMatch(): boolean {
    if (this.cache.meta) {
      return true;
    }

    console.warn("selfserv meta data is is undefined");

    let errorRoute = "404";
    if (this.cache.errorStatus === 400 || this.cache.errorStatus >= 500) {
      errorRoute = "error";
    }

    this.router.navigate([errorRoute], { skipLocationChange: true });
    return false;
  }
}

export const routes: Routes = [
  {
    path: "error",
    component: ErrorComponent,
  },
  {
    path: "about",
    component: AboutComponent,
  },
  {
    path: "404",
    component: NotFoundComponent,
  },
  {
    path: "",
    canMatch: [canMatchQna],
    loadChildren: () =>
      import("./pages/+qna/qna_page.module").then((m) => m.QnaPageModule),
  },
];

@NgModule({
  imports: [RouterModule.forRoot(routes, { anchorScrolling: "enabled" })],
  exports: [RouterModule],
  providers: [CanMatchQna],
})
export class AppRoutingModule {}
